import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import logo_sm from '../img/logo_sm.png';

function NavBar() {
  return (
    <Navbar expand="lg" variant="dark" bg="dark" data-bs-theme="dark">
      <Container>
        <Navbar.Brand href="/">
          <img src={logo_sm} alt="Logo" className="d-inline-block align-text-top" height="24" />
          shcastillo Games
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">Inicio</Nav.Link>
            <Nav.Link href="/games">Juegos</Nav.Link>
            <Nav.Link href="/news">Noticias</Nav.Link>
            <Nav.Link href="/roadmap">Roadmap</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;